/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { taskFor } from 'ember-concurrency-ts';
import { ReactRoute } from 'embercom/lib/react-route';

class DeployOverviewRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;
  @service declare appService: {
    app: {
      hasStandalonePlatform: (platform: string) => boolean;
      id: string;
      canStandalonePlatformAccessReactIntegrationPages: boolean;
      canUseStandaloneConnectPage: boolean;
    };
  };

  async beforeModel() {
    if (this.reactEnabled()) {
      return;
    }

    await Promise.all([
      this.finStandaloneService.initialize(),
      this.finStandaloneService.intercomMessengerConfig.ruleset.promise,
      taskFor(this.finStandaloneService.loadAiContentLibrarySummary).last!,
    ]);
  }

  reactEnabled() {
    return this.appService.app.canUseStandaloneConnectPage;
  }
}

export default ReactRoute(DeployOverviewRoute);
